import {
  CodeSandboxOutlined,
  SolutionOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { BiTask } from "react-icons/bi";
import { BsBuildingFillGear } from "react-icons/bs";
import { FaBusinessTime, FaRegMoneyBillAlt } from "react-icons/fa";
import { GrUserAdmin } from "react-icons/gr";
import { HiOutlineUserGroup } from "react-icons/hi";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { IoTicketOutline } from "react-icons/io5";
import { LuBuilding2 } from "react-icons/lu";
import {
  MdOutlineColorLens,
  MdOutlineContactPhone,
  MdOutlineLeaderboard,
  MdPolicy,
} from "react-icons/md";
import { RiBillLine } from "react-icons/ri";
import { TbAward, TbFileInvoice } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

export default function useSettingNav() {
  const { t } = useTranslation();
  return [
    {
      label: (
        <NavLink to="/admin/company-settings">
          <span>{t("navigation.companySettings")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["readAll-setting", "update-setting"],
        operator: "or",
      },
      key: "invoiceSetting",
      icon: <BsBuildingFillGear />,
    },
    {
      label: (
        <NavLink to="/admin/setup/app-settings">
          <span>{t("navigation.appSettings")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["readAll-emailConfig", "readAll-duplicateConfig"],
        operator: "or",
      },
      key: "appSettings",
      icon: <BsBuildingFillGear />,
    },


    {
      label: t("navigation.employeeManage"),
      key: "employee-manage",
      icon: <TeamOutlined />,
      permit: {
        permissions: [
          "create-user",
          "readAll-user",
          "readAll-role",
          "readAll-department",
          "readAll-designation",
          "readAll-shift",
          "readAll-employmentStatus",
          "readAll-announcement",
          "readAll-award",
          "create-role",
          "create-department",
          "create-designation",
          "create-shift",
          "create-employmentStatus",
          "create-announcement",
          "create-award",
        ],
        operator: "or",
      },
      children: [
        {
          label: (
            <NavLink to="/admin/staff">
              <span>{t("navigation.staff")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["readAll-user"],
            operator: "or",
          },
          key: "staff",
          icon: <HiOutlineUserGroup />,
        },

        {
          label: (
            <NavLink to="/admin/role">
              <span>{t("navigation.rolePermission")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["readAll-role", "create-role"],
            operator: "or",
          },
          key: "role",
          icon: <GrUserAdmin />,
        },
        {
          label: (
            <NavLink to="/admin/department">
              <span>{t("navigation.department")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["readAll-department", "create-department"],
            operator: "or",
          },
          key: "department",
          icon: <HiOutlineBuildingOffice2 />,
        },
        {
          label: (
            <NavLink to="/admin/shift">
              <span>{t("navigation.shift")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["readAll-shift", "create-shift"],
            operator: "or",
          },
          key: "shift",
          icon: <FaBusinessTime />,
        },
        {
          label: (
            <NavLink to="/admin/designation">
              <span>{t("navigation.designation")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["readAll-designation", "create-designation"],
            operator: "or",
          },
          key: "designation",
          icon: <SolutionOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/employment-status">
              <span>{t("navigation.employmentStatus")}</span>
            </NavLink>
          ),
          permit: {
            permissions: [
              "readAll-employmentStatus",
              "create-employmentStatus",
            ],
            operator: "or",
          },
          key: "employmentStatus",
          icon: <FaBusinessTime />,
        },

        {
          label: (
            <NavLink to="/admin/award">
              <span>{t("navigation.award")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["readAll-award", "create-award"],
            operator: "or",
          },
          key: "award",
          icon: <TbAward />,
        },
      ],
    },
    /* {
      label: t("navigation.contactSetup"),
      permit: {
        permissions: [
          "create-contactSource",
          "readAll-contactSource",
          "create-contactStage",
          "readAll-contactStage",
        ],
        operator: "or",
      },
      key: "contactSetup",
      icon: <MdOutlineContactPhone />,
      children: [
        {
          label: (
            <NavLink to="/admin/contact-stage">
              <span>{t("navigation.contactStage")}</span>
            </NavLink>
          ),
          key: "contactStage",
          icon: <UsergroupAddOutlined />,
        },
      ],
    }, */
    {
      label: t("navigation.companySetup"),
      permit: {
        permissions: [
          "create-companyType",
          "readAll-companyType",
          "create-industry",
          "readAll-industry",
          "create-contactSource",
          "readAll-contactSource",
        ],
        operator: "or",
      },
      key: "companySetup",
      icon: <LuBuilding2 />,
      children: [
        {
          label: (
            <NavLink to="/admin/company-type">
              <span>{t("navigation.companyType")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-companyType", "readAll-companyType"],
            operator: "or",
          },
          key: "companyType",
          icon: <UsergroupAddOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/industry">
              <span>{t("navigation.industry")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-industry", "readAll-industry"],
            operator: "or",
          },
          key: "Industry",
          icon: <UsergroupAddOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/contact-source">
              <span>{t("navigation.contactSource")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-contactSource", "readAll-contactSource"],
            operator: "or",
          },
          key: "contactSource",
          icon: <UsergroupAddOutlined />,
        },
      ],
    },
    /* {
      label: t("navigation.opportunitySetup"),
      permit: {
        permissions: [
          "create-opportunitySource",
          "readAll-opportunitySource",
          "create-opportunityStage",
          "readAll-opportunityStage",
          "create-opportunityType",
          "readAll-opportunityType",
        ],
        operator: "or",
      },
      key: "opportunitySetup",
      icon: <FaRegMoneyBillAlt />,
      children: [
        {
          label: (
            <NavLink to="/admin/opportunity-source">
              <span>{t("navigation.opportunitySource")}</span>
            </NavLink>
          ),
          permit: {
            permissions: [
              "create-opportunitySource",
              "readAll-opportunitySource",
            ],
            operator: "or",
          },
          key: "opportunitySource",
          icon: <UsergroupAddOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/opportunity-stage">
              <span>{t("navigation.opportunityStage")}</span>
            </NavLink>
          ),
          permit: {
            permissions: [
              "create-opportunityStage",
              "readAll-opportunityStage",
            ],
            operator: "or",
          },
          key: "opportunityStage",
          icon: <UsergroupAddOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/opportunity-type">
              <span>{t("navigation.opportunityType")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-opportunityType", "readAll-opportunityType"],
            operator: "or",
          },
          key: "opportunityType",
          icon: <UsergroupAddOutlined />,
        },
      ],
    }, */
    {
      label: t("navigation.taskSetup"),
      permit: {
        permissions: [
          "create-taskType",
          "readAll-taskType",
          "create-taskStatus",
          "readAll-taskStatus",
        ],
        operator: "or",
      },
      key: "taskSetup",
      icon: <BiTask />,
      children: [
        {
          label: (
            <NavLink to="/admin/task-status">
              <span>{t("navigation.taskStatus")}</span>
            </NavLink>
          ),
          key: "CemTaskStatus",
          icon: <UsergroupAddOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/task-type">
              <span>{t("navigation.taskType")}</span>
            </NavLink>
          ),
          key: "CemTaskType",
          icon: <UsergroupAddOutlined />,
        },
      ],
    },
    /* {
      label: t("navigation.ticketSetup"),
      permit: {
        permissions: [
          "create-ticketStatus",
          "readAll-ticketStatus",
          "create-ticketCategory",
          "readAll-ticketCategory",
        ],
        operator: "or",
      },
      key: "ticketSetup",
      icon: <IoTicketOutline />,
      children: [
        {
          label: (
            <NavLink to="/admin/ticket-status">
              <span>{t("navigation.ticketStatus")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-ticketStatus", "readAll-ticketStatus"],
            operator: "or",
          },
          key: "CemTicketStatus",
          icon: <UsergroupAddOutlined />,
        },

        {
          label: (
            <NavLink to="/admin/Ticket-category">
              <span>{t("navigation.ticketCategory")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-ticketCategory", "readAll-ticketCategory"],
            operator: "or",
          },
          key: "CemTicketCategory",
          icon: <UsergroupAddOutlined />,
        },
      ],
    }, */

    {
      label: t("navigation.leadSetup"),
      permit: {
        permissions: ["create-leadSource", "readAll-leadSource", "readAll-leadStatus", "readAll-interest"],
        operator: "or",
      },
      key: "leadSetup",
      icon: <MdOutlineLeaderboard />,
      children: [
        {
          label: (
            <NavLink to="/admin/lead-source">
              <span>{t("navigation.leadSource")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-leadSource", "readAll-leadSource"],
            operator: "or",
          },
          key: "leadSource",
          icon: <RiBillLine />,
        },
        {
          label: (
            <NavLink to="/admin/lead-status">
              <span>{t("navigation.leadStatus") || "Lead Status"}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-leadStatus", "readAll-leadStatus"],
            operator: "or",
          },
          key: "leadStatus",
          icon: <MdOutlineColorLens />,
        },
        {
          label: (
            <NavLink to="/admin/campaign-code">
              <span>{t("navigation.campaignCode") || "Campaign Code"}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-campaignCode", "readAll-campaignCode"],
            operator: "or",
          },
          key: "campaignCode",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/setup/lead-fields">
              <span>{t("navigation.leadFields") || "Lead Fields"}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["update-setting"],
            operator: "or",
          },
          key: "leadFields",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/setup/deal-fields">
              <span>{t("navigation.dealFields") || "Deal Fields"}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["update-setting"],
            operator: "or",
          },
          key: "dealFields",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/setup/interest">
              <span>{t("navigation.interest") || "Interest"}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["readAll-interest"],
            operator: "or",
          },
          key: "interest",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/setup/semester-registered">
              <span>{t("navigation.semesterRegistered") || "Semester Registered"}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["readAll-semesterRegistered"],
            operator: "or",
          },
          key: "semesterRegistered",
          icon: <UnorderedListOutlined />,
        },
      ],
    },
    /* {
      label: t("navigation.productSetup"),
      permit: {
        permissions: ["create-productCategory", "readAll-productCategory"],
        operator: "or",
      },
      key: "productSetup",
      icon: <CodeSandboxOutlined />,
      children: [
        {
          label: (
            <NavLink to="/admin/product-category">
              <span>{t("navigation.productCategory")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-productCategory", "readAll-productCategory"],
            operator: "or",
          },
          key: "product-category",
          icon: <UnorderedListOutlined />,
        },
      ],
    }, */

    /* {
      label: (
        <NavLink to="/admin/quote-stage">
          <span>{t("navigation.quoteStageSetup")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-quoteStage", "readAll-quoteStage"],
        operator: "or",
      },
      key: "quoteStageSetup",
      icon: <TbFileInvoice />,
    }, */
    /* {
      label: (
        <NavLink to="/admin/priority">
          <span>{t("navigation.priority")}</span>
        </NavLink>
      ),
      key: "Priority",

      permit: {
        permissions: ["create-priority", "readAll-priority"],
        operator: "or",
      },

      icon: <UsergroupAddOutlined />,
    }, */
    {
      label: t("navigation.universitySetup"),
      permit: {
        permissions: ["create-major", "readAll-major", "create-degree", "readAll-degree"],
        operator: "or",
      },
      key: "universitySetup",
      icon: <LuBuilding2 />,
      children: [
        {
          label: (
            <NavLink to="/admin/setup/major">
              <span>{t("navigation.major") || "Major"}</span>
            </NavLink>
          ),
          key: "setup-major",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/setup/degree">
              <span>{t("navigation.degree") || "Degree"}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-degree", "readAll-degree"],
            operator: "or",
          },
          key: "setup-degree",
          icon: <UnorderedListOutlined />,
        },
      ],
    },
  ];
}
